import { getUrlWithSchema } from "@shared/common/utils/url";
import type { ExternalSiteRule } from "../../types";
import { GODOMALL_PAGE, SITE_TYPE } from "./const";

const godomall: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async ({ html, responseUrl }) => {
    if (!html.innerHTML.includes("고도몰5 통화정책")) {
      return "INVALID";
    }

    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
    };
  },

  pageRules: [
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.LOGIN.target,
      label: "로그인 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.LOGIN.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.SIGNUP_INTRO.target,
      label: "가입하기 페이지 - 인트로",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.SIGNUP_INTRO.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.SIGNUP_AGREEMENT.target,
      label: "가입하기 페이지 - 약관동의",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          GODOMALL_PAGE.SIGNUP_AGREEMENT.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.SIGNUP_MAIN.target,
      label: "가입하기 페이지 - 메인",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.SIGNUP_MAIN.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.SIGNUP_COMPLETE.target,
      label: "가입하기 완료 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          GODOMALL_PAGE.SIGNUP_COMPLETE.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.MY_PAGE.target,
      label: "마이 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.MY_PAGE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.FIND_ID.target,
      label: "아이디 찾기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.FIND_ID.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.FIND_PASSWORD.target,
      label: "비밀번호 찾기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.FIND_PASSWORD.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.CART.target,
      label: "장바구니 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.CART.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.POLICY.target,
      label: "이용약관 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.POLICY.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.PRIVACY.target,
      label: "개인정보처리방침 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.PRIVACY.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.CHECK_ORDER.target,
      label: "주문/배송 내역 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.CHECK_ORDER.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.CANCEL_ORDER.target,
      label: "취소/반품/교환 내역 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.CANCEL_ORDER.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.REFUND_LIST.target,
      label: "환불/입금 내역 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.REFUND_LIST.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.COUPON.target,
      label: "쿠폰 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.COUPON.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.MILEAGE.target,
      label: "마일리지 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.MILEAGE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.WISH_LIST.target,
      label: "관심상품 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.WISH_LIST.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.DELIVERY_ADDR_LIST.target,
      label: "배송지 관리 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          GODOMALL_PAGE.DELIVERY_ADDR_LIST.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.MEMBER_MODIFY.target,
      label: "개인정보 관리 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.MEMBER_MODIFY.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.MY_PAGE_PASSWORD.target,
      label: "개인정보 관리 페이지 - 비밀번호 입력 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          GODOMALL_PAGE.MY_PAGE_PASSWORD.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: GODOMALL_PAGE.MY_PAGE_QA.target,
      label: "1:1 온라인 상담 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${GODOMALL_PAGE.MY_PAGE_QA.url}`;
      },
    },
  ],
};

export default godomall;
